export default __webpack_public_path__ + "/dist/images/connections-inactive.445ae5bc2af5f9acbc7bf049679b4d6b.svg";